import { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Switch,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import useProdutoController from "../controllers/ProdutoController";
import { Margin } from "../../../../theme/styles/Utils";
import Chip from "../../../../components/basics/Chip";
import { HeaderAccordion, HeaderCard } from "../styles/Produto";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

export default function AccordionProdutoIntegraccao() {
  const {
    woocomerceShowSite,
    setWoocomerceShowSite,
    woocomerceUpdateSite,
    setWoocomerceUpdateSite,
    lunetNegativeStock,
    setLunetNegativeStock,

    expanded,
    errors,
  } = useContext(ProdutoContext);
  const { handleChangeOpenAcordion } = useProdutoController();

  const { queryParams } = useContext(QueryParamsContext);

  return (
    <Grid item xs={12}>
      <Accordion
        expanded={expanded.integration || false}
        onChange={() => handleChangeOpenAcordion("integration")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <HeaderAccordion>
            <Grid container>
              <Grid item xs={12}>
                <Chip
                  bgcolor={
                    !expanded.integration &&
                    errors.accordions &&
                    errors.accordions.includes("integration")
                      ? "red"
                      : "default"
                  }
                  textcolor={
                    !expanded.integration &&
                    errors.accordions &&
                    errors.accordions.includes("integration")
                      ? "white"
                      : "default"
                  }
                  label="INTEGRAÇÃO"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} alignItems="center">
            <Grid item felx={1} lg={6}>
              <Card line="left">
                <HeaderCard>
                  <Grid container>
                    <Chip label="WOOCOMERCE | QYON SHOP" bgcolor="secondary" />
                  </Grid>
                </HeaderCard>

                <Grid item xs={12}>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={woocomerceShowSite}
                        onChange={() =>
                          setWoocomerceShowSite((current) => !current)
                        }
                        color="primary"
                      />
                    }
                    label="Exibir no Site"
                    labelPlacement="end"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={woocomerceUpdateSite}
                        onChange={() =>
                          setWoocomerceUpdateSite((current) => !current)
                        }
                        color="primary"
                      />
                    }
                    label="Atualizar no Site"
                    labelPlacement="end"
                    disabled={queryParams.idversao === "16"}
                  />
                </Grid>
              </Card>
            </Grid>

            <Grid item xs={3} lg={6}>
              <Card line="left">
                <HeaderCard>
                  <Grid container>
                    <Chip label="LÚNET" bgcolor="secondary" />
                  </Grid>
                </HeaderCard>
                <Margin top="10">
                  <Grid item xs={12}>
                    <SelectErp
                      error={errors.lunetNegativeStock ? true : false}
                      helperText={errors.lunetNegativeStock || ""}
                      label="Permitir Estoque Negativo"
                      disabled={queryParams.idversao === "16"}
                      value={lunetNegativeStock}
                      setValue={setLunetNegativeStock}
                      optionsList={[
                        { label: "Sim", id: "S" },
                        { label: "Não", id: "N" },
                        {
                          label: "Utilizar configuração do Grupo de Estoque",
                          id: "G",
                        },
                      ]}
                      descriptionField="label"
                    />
                  </Grid>
                </Margin>
              </Card>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
